import { PermissionsEnum } from "@/auth/interfaces";
import { a11yProps, sizeTab, useCheckPermissions } from "@/shared";
import { CustomTabPanel, SingleTableBoxScene } from "@/shared/components/ui";
import { Box, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import TableSolicitudCapacidadCorporativo from "../../shared/componente/table-solicitud-capacidad-corporativo/TableSolicitudCapacidadCorporativo";

export default function SolicitudesCapacidadCorporativoPage() {

  // ===========================================================================
  // CAMBIAR POR PERMISO ADECUADO
  // ===========================================================================
  useCheckPermissions(PermissionsEnum.api_view_factibilidadcoorporativa);
  const [valueTab, setValueTab] = useState(0);

  return (
    <SingleTableBoxScene
      title={"Solicitud Enlace Corporativo"}
      visibleReport={true}
    >
      <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 2 }} >
        <Tabs
          value={valueTab}
          onChange={(_event: React.SyntheticEvent, newValue: number) => {
            setValueTab(newValue);
          }}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="scrollable force tabs preventa"
        >
          <Tab label={'Solicitud'} {...a11yProps(0)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={valueTab} index={0}>
        <TableSolicitudCapacidadCorporativo />
      </CustomTabPanel>

    </SingleTableBoxScene>

  );

}